var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentrelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 20,
    viewBox: "0 0 71 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_437_2534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4843 6.22112V14.4573L8.13293 18.8419L0.781597 14.4573V6.22112L-3.8147e-05 5.61548V14.9413L8.13404 19.7388L16.2684 14.9413V5.61661L15.4843 6.22112Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8962 5.93151V13.8051L8.13206 17.2198L2.36795 13.8051V5.93151L7.78956 9.15319L8.13151 9.37133L8.47346 9.15319L13.8962 5.93151ZM14.5558 4.76855L8.13179 8.59612L1.70689 4.76855V14.1917L8.13095 17.995L14.555 14.1917L14.5558 4.76855Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13167 7.53014L8.93781 7.0456C8.85193 6.90687 8.7332 6.79209 8.59241 6.71171C8.45162 6.63133 8.29326 6.58789 8.13167 6.58532C7.96911 6.58268 7.80877 6.62392 7.66709 6.70482C7.52544 6.7857 7.40757 6.90329 7.32553 7.0456L8.13167 7.53014Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98244 6.24664C6.21465 5.92258 6.51959 5.65915 6.87206 5.47809C7.22454 5.29703 7.61446 5.20353 8.00963 5.2053C8.42523 5.2048 8.83451 5.30854 9.20099 5.50721C9.56747 5.7059 9.87976 5.99335 10.11 6.34399L10.7697 5.95652C10.4761 5.49657 10.0754 5.11685 9.60286 4.85083C9.13034 4.58478 8.60052 4.44058 8.06006 4.43094C7.51962 4.4213 6.98512 4.54649 6.50363 4.79552C6.02218 5.04451 5.6085 5.40969 5.2991 5.85887L5.98244 6.24664Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24773 5.22893C4.66072 4.56451 5.23412 4.01782 5.9137 3.6406C6.59328 3.26337 7.35659 3.06807 8.13141 3.07316C8.90533 3.07316 9.66678 3.27067 10.3455 3.64743C11.0243 4.02418 11.5986 4.56806 12.0154 5.22893L12.724 4.81719C12.2406 4.03143 11.5677 3.38337 10.7687 2.93408C9.96971 2.48478 9.07104 2.24905 8.1573 2.24911C7.24262 2.24386 6.342 2.47737 5.54215 2.92714C4.74233 3.37692 4.07021 4.02784 3.59057 4.81719L4.24773 5.22893Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36656 4.09024C2.98096 3.10393 3.83176 2.29134 4.83967 1.72822C5.84758 1.1651 6.97974 0.869771 8.13067 0.869771C9.28157 0.869771 10.4138 1.1651 11.4217 1.72822C12.4296 2.29134 13.2804 3.10393 13.8948 4.09024L14.5545 3.70277C13.8743 2.59771 12.9276 1.68646 11.8036 1.05495C10.6797 0.423448 9.41551 0.0925036 8.13039 0.0933356C6.84324 0.0813652 5.575 0.407557 4.44927 1.04012C3.32354 1.67268 2.37872 2.59003 1.70689 3.70277L2.36656 4.09024Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.429 12.3263V14.2171H18.6597V12.714L24.1802 6.14934H18.7817V4.25854H27.2335V5.76046L21.7375 12.3263H27.429Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8949 5.15628C28.7718 5.04766 28.6735 4.91365 28.6058 4.76322C28.5384 4.61281 28.5033 4.44949 28.5033 4.28424C28.5033 4.11901 28.5384 3.95569 28.6058 3.80526C28.6735 3.65485 28.7718 3.52084 28.8949 3.41222C29.17 3.16411 29.5292 3.03382 29.8973 3.04875C30.261 3.03291 30.618 3.15345 30.8998 3.3874C31.0256 3.4877 31.1264 3.61659 31.1941 3.76363C31.2618 3.91068 31.2943 4.07183 31.2896 4.23402C31.2952 4.40704 31.2632 4.5792 31.1958 4.73831C31.1284 4.89739 31.0273 5.03951 30.8998 5.15457C30.6244 5.40243 30.2652 5.53259 29.8973 5.51777C29.5323 5.51435 29.1792 5.3864 28.8949 5.15457V5.15628ZM28.7723 6.56137H31.0198V14.2159H28.7732L28.7723 6.56137Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.0822 7.31215C40.667 7.86923 40.9613 8.71725 40.9613 9.83142V14.1915H38.7139V10.1464C38.7445 9.66179 38.6067 9.18171 38.324 8.7895C38.1765 8.63384 37.9977 8.51219 37.7994 8.43277C37.6014 8.35336 37.3887 8.31804 37.176 8.32923C36.9298 8.3176 36.6839 8.35664 36.4531 8.44393C36.2222 8.53123 36.0112 8.66502 35.8327 8.83718C35.6497 9.04786 35.5099 9.29355 35.4217 9.55976C35.3337 9.82597 35.2989 10.1074 35.3195 10.3874V14.1664H33.0965V6.51267H35.2215V7.40895C35.5272 7.07754 35.9028 6.82078 36.3205 6.65801C36.7811 6.48132 37.2695 6.39105 37.7618 6.3916C38.622 6.39304 39.4499 6.72156 40.0822 7.31215Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3808 3.67847V14.2161H58.2559V13.3438C57.694 13.9979 56.9123 14.3371 55.8375 14.3371C55.1491 14.3409 54.47 14.1746 53.8587 13.8526C53.2751 13.5441 52.7978 13.0625 52.491 12.472C52.1543 11.8308 51.978 11.1154 51.978 10.3889C51.978 9.66243 52.1543 8.94708 52.491 8.30582C52.8184 7.73098 53.2904 7.2544 53.8587 6.92469C54.4689 6.59989 55.1486 6.4334 55.8375 6.44015C56.2632 6.4169 56.6887 6.48717 57.085 6.64609C57.4812 6.80503 57.8388 7.0489 58.1334 7.36098V3.65308H60.3808V3.67847ZM57.6452 11.9147C57.8354 11.7067 57.983 11.4625 58.0794 11.1963C58.1757 10.9301 58.2191 10.6472 58.2069 10.3639C58.2275 9.79262 58.0256 9.23601 57.6452 8.81378C57.2654 8.44099 56.7572 8.23258 56.2284 8.23258C55.6996 8.23258 55.1914 8.44099 54.8114 8.81378C54.4488 9.24681 54.25 9.79628 54.25 10.3642C54.25 10.9322 54.4488 11.4816 54.8114 11.9147C54.9951 12.1057 55.216 12.2559 55.4596 12.356C55.7035 12.4561 55.9653 12.5037 56.2282 12.496C56.491 12.5015 56.7522 12.4528 56.9956 12.3529C57.2392 12.253 57.4603 12.104 57.6452 11.915V11.9147Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.2254 6.56152V14.2161H68.1V13.2955C67.8056 13.6288 67.4372 13.8862 67.0254 14.0465C66.6069 14.2208 66.1588 14.3113 65.7061 14.3129C64.8186 14.3547 63.9501 14.0416 63.2882 13.4409C62.6775 12.8595 62.4085 12.0115 62.4085 10.8728V6.56152H64.656V10.5581C64.656 11.7936 65.1692 12.399 66.2193 12.399C66.4579 12.4084 66.696 12.3681 66.9185 12.2808C67.1412 12.1934 67.3439 12.0607 67.5141 11.891C67.8652 11.4562 68.0401 10.9021 68.0025 10.3414V6.56152H70.2254Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M50.708 4.26001H43.1356V6.10114H50.708V4.26001Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M50.0974 8.28125H43.1356V10.0738H50.0974V8.28125Z",
    fill: "#E97A26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M50.9035 12.3506H43.1356V14.1917H50.9035V12.3506Z",
    fill: "#E97A26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_437_2534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.4502,
    height: 19.8335,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrelogo);
export default __webpack_public_path__ + "static/media/centrelogo.f0bd2f47103f7086fd1318cb76e9485f.svg";
export { ForwardRef as ReactComponent };